/* eslint-disable @typescript-eslint/camelcase */
import { DataLayerEvent } from 'Project/ts/library/eventTacker';

import { PlanElementData } from './types';

const getPriceType = (couponApplied: string): string => {
    if (couponApplied) {
        return 'discount';
    }

    return 'full_price';
};

export function mapPlanToItemData(planData: PlanElementData, index: number = 0): DataLayerEvent {
    const { priceNumber, code, plan, couponApplied } = planData;

    return {
        item_name: `flaticon_${plan.toLocaleLowerCase()}_premium-1`,
        item_id: code,
        price: Number(priceNumber),
        item_brand: 'flaticon',
        item_category: 'premium-1',
        item_category2: plan.toLocaleLowerCase(),
        item_category3: getPriceType(couponApplied),
        item_list_name: 'pricing',
        coupon: couponApplied,
        index: index + 1,
        quantity: 1,
    };
}
